import { render } from "./View.pug?vue&type=template&id=10863e93&ts=true&lang=pug&external"
import script from "./View.ts?vue&type=script&lang=ts&external"
export * from "./View.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/companies/View.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10863e93"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10863e93', __exports__)) {
    api.reload('10863e93', __exports__)
  }
  
  module.hot.accept("./View.pug?vue&type=template&id=10863e93&ts=true&lang=pug&external", () => {
    api.rerender('10863e93', render)
  })

}


export default __exports__